<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-6 order-xl-1">
        <div>
          <user-edit-card :user="user" />
        </div>
      </div>
      <div class="col-xl-6 order-xl-2">
        <user-password-card :user="user" />
      </div>
    </div>
  </div>
</template>
<script>
import UserEditCard from "@/views/Gestion/UserProfile/UserEditCard.vue";
import UserPasswordCard from "@/views/Gestion/UserProfile/UserPasswordCard.vue";

export default {
  layout: "DashboardLayout",

  components: {
    UserEditCard,
    UserPasswordCard,
  },

  data() {
    return {
      user: {
        type: "profile",
      },
    };
  },
  created() {
    this.getProfile();
  },

  methods: {
    async getProfile() {
      await this.$store.dispatch("profile/me");
      this.user = await { ...this.$store.getters["profile/me"] };
    },
  },
};
</script>
